import { useEffect, useState } from "react";
import { Box, Typography, Grid, Button, Chip } from "@mui/material";
import RotatingCursor from "./RoundedCursor";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import { NorthEast } from "@mui/icons-material";


// projectsData.ts
const projectsData = [
    {
        id: 1,
        title: "Wolfpack – Advanced Investment and Trading Platform",
        category: "Web",
        image: "/Images/Works/1.png",
        tags: ["#trading", "#fintech", "#crypto", "#aiinvest", "#wealth", "#market"],
        name: "wolfpack"
    },
    {
        id: 2,
        title: "Belong – Digital Connectivity Mobile Platform",
        category: "Mobile",
        image: "/Images/Works/2.png",
        tags: ["#telco", "#connect", "#mobile", "#data", "#ux", "#network"],
        name: "belong"
    },
    {
        id: 3,
        title: "Redarc Electronics – Installation Management Portal",
        category: "Web",
        image: "/Images/Works/3.png",
        tags: ["#installation", "#asset", "#warranty", "#service", "#replacement", "#jobs"],
        name: "redarc"
    },
    {
        id: 4,
        title: "Mystery Management – All-in-One Mystery Shopping Platform",
        category: "Web",
        image: "/Images/Works/4.png",
        tags: ["#mysteryshop", "#cxinsights", "#service", "#smartanalytics", "#experience", "#metrics"],
        name: "mysterymanagement"
    },

];


const categories = ["All Work", "Web", "Mobile"];

export default function OurWorks() {
    const [activeCategory, setActiveCategory] = useState("All Work");
    const [hovered, setHovered] = useState(false);
    const navigate = useNavigate()


    const filteredProjects =
        activeCategory === "All Work"
            ? projectsData
            : projectsData.filter(
                (project) => project.category === activeCategory
            );

    const leftColumn = filteredProjects.filter((_, index) => index % 2 === 0);
    const rightColumn = filteredProjects.filter((_, index) => index % 2 !== 0);

    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animation happens only once
        });
    }, []);

    return (
        <Box>
            {hovered && <RotatingCursor />}
            <Box className='d-flex align-items-center justify-content-between mb-4'>
                <Typography className="fs-52 text-color-main" data-aos="fade-up" lineHeight={'normal'} fontWeight={600}>Our Work</Typography>
                <Box className='mt-3 d-flex justify-content-end'>
                    <Box onClick={() => { navigate('/clients') }} className='align-items-center' display={{ xs: "none", md: 'flex' }} order={3}>
                        <Typography className='fs-18   text-color-main'>Explore more</Typography>
                        <Box className='message-bg' maxHeight={'55px'}><NorthEast sx={{ color: 'var(--primary-dark-color)' }} /></Box>
                    </Box>
                </Box>
            </Box>
            {/* Menu */}
            {/* <Box sx={{ display: "flex", gap: 3, mb: 4 }}>
                {categories.map((cat) => (
                    <Button
                        key={cat}
                        onClick={() => setActiveCategory(cat)}
                        className={`fs-14 mt-2 ${activeCategory === cat ? 'text-color-main fw-bold' : 'text-grey'}`}
                        sx={{
                            borderBottom: activeCategory === cat ? "2px solid #47AAA7" : "none",
                            borderRadius: 0
                        }}
                    >
                        {cat}
                    </Button>
                ))}
            </Box> */}

            {/* Projects Grid */}
            <Grid container spacing={2} display={{ xs: "none", md: "flex" }}>
                {/* LEFT COLUMN */}
                <Grid size={6}>
                    {leftColumn.map((project) => (
                        <Box onClick={() => { navigate(`/client-details/${project?.name}`) }} data-aos="fade-up" key={project.id} mb={3} >
                            <Box className="border-10" overflow={'hidden'}
                                onMouseEnter={() => setHovered(true)}
                                onMouseLeave={() => setHovered(false)}
                                sx={{
                                    cursor: "none", // hide default cursor
                                }}
                                // borderRadius={'20px'}
                                >
                                <Box
                                className="border-10"
                                    component="img"
                                    src={project.image}
                                    alt={project.title}
                                    

                                    sx={{
                                        width: "100%",
                                        // maxHeight: '700px',
                                        objectFit: "cover",
                                        // borderRadius: '20px',
                                        transition: "transform 0.5s ease",
                                        "&:hover": {
                                            transform: "scale(1.1)",
                                        },
                                    }}
                                />
                            </Box>

                            <Box sx={{ display: "flex", gap: 1, my: 1 }}>
                                {project.tags.map((tag, index) => (
                                    <Chip className="text-color custom-bg" key={index} label={tag} size="small" />
                                ))}
                            </Box>

                            <Typography variant="h6" className="text-color" fontWeight={500}>
                                {project.title}
                            </Typography>
                        </Box>
                    ))}
                </Grid>

                {/* RIGHT COLUMN */}
                <Grid size={6}>
                    {rightColumn.map((project, index) => (
                        <Box data-aos="fade-up" onClick={() => { navigate(`/client-details/${project?.name}`) }} key={project.id} mt={index === 0 && '200px'} mb={3}>
                            <Box className='border-10' overflow={'hidden'}
                                onMouseEnter={() => setHovered(true)}
                                onMouseLeave={() => setHovered(false)}
                                sx={{
                                    cursor: "none", // hide default cursor
                                }}
                                // borderRadius={'20px'}
                                >
                                <Box
                                className="border-10"
                                    component="img"
                                    src={project.image}
                                    alt={project.title}
                                    sx={{
                                        width: "100%",
                                        // maxHeight: '500px',
                                        objectFit: "cover",
                                        // borderRadius: '20px',
                                        transition: "transform 0.5s ease",
                                        "&:hover": {
                                            transform: "scale(1.1)",
                                        },
                                    }}
                                />
                            </Box>

                            <Box sx={{ display: "flex", gap: 1, my: 1 }}>
                                {project.tags.map((tag, index) => (
                                    <Chip key={index} className="text-color custom-bg" label={tag} size="small" />
                                ))}
                            </Box>

                            <Typography variant="h6" className="text-color" fontWeight={500}>
                                {project.title}
                            </Typography>
                        </Box>
                    ))}
                </Grid>
            </Grid>
            <Grid container display={{ xs: "grid", md: "none" }}>

                {/* RIGHT COLUMN */}
                <Grid size={12}>
                    {filteredProjects.map((project, index) => (
                        <Box key={project.id} mb={3}>
                            <Box overflow={'hidden'}
                                onMouseEnter={() => setHovered(true)}
                                onMouseLeave={() => setHovered(false)}
                                sx={{
                                    cursor: "none", // hide default cursor
                                }}
                                borderRadius={'20px'}>
                                <Box
                                    component="img"
                                    src={project.image}
                                    alt={project.title}
                                    sx={{
                                        width: "100%",
                                        maxHeight: '500px',
                                        objectFit: "cover",
                                        borderRadius: '20px',
                                        transition: "transform 0.5s ease",
                                        "&:hover": {
                                            transform: "scale(1.1)",
                                        },
                                    }}
                                />
                            </Box>

                            <Box sx={{ display: "flex", gap: 1, my: 1 }}>
                                {project.tags.map((tag, index) => (
                                    <Chip key={index} className="text-color custom-bg" label={tag} size="small" />
                                ))}
                            </Box>

                            <Typography variant="h6" className="text-color" fontWeight={500}>
                                {project.title}
                            </Typography>
                        </Box>
                    ))}
                </Grid>
            </Grid>

        </Box>
    );
}
